<template>
  <div class="bt-1 mt-25" v-show="!activityMode || activityMode === 'schedule' || activityMode === 'both'">
    <div>
      <div class="pt-20">
        <dynamic-scheduling-overview @edit-dynamic-schedule="openDynamicSchedulerModalEdit" :studyData="studyData" />
      </div>
    </div>

    <div class="pb-20" v-show="showAddDynamicSchedulingButton">
      <div class="row">
        <button class="dynamic-activity-scheduler-btn" @click="openDynamicSchedulerModalAdd"><span class="das-icon"></span>Add Dynamic Scheduling</button>
      </div>
    </div>
    <div class="divider-line"></div>

    <dynamic-activity-scheduling-modal ref="DynamicActivitySchedulingModal" :studyData="studyData" :taskDetails="taskDetails" :triggersRelatedDetails="triggersRelatedDetails" />
  </div>
</template>
<script>
import DynamicActivitySchedulingModal from "./dynamic-activity-scheduling-modal";
import { mapGetters, mapActions } from "vuex";
import DynamicSchedulingOverview from "./dynamic-scheduling-overview";
import { cloneDeep } from "lodash";
import _ from "lodash";
import DynamicSchedulingService from "@/services/dynamic-scheduling";
import * as DynamicSchedulingConstants from "@/constants/dynamicSchedulingConstants";

export default {
  name: "dynamic-schedule-section",
  components: {
    DynamicActivitySchedulingModal,
    DynamicSchedulingOverview
  },
  props: {
    activityMode: {
      type: String,
      default: "schedule"
    },
    taskDetails: {
      type: [Object, String],
      default: null
    },
    studyData: {
      type: Object,
      default: null,
      required: false
    },
    schedulerDetails: {
      type: [Object, String],
      default: null
    }
  },
  computed: {
    showAddDynamicSchedulingButton() {
      return (this.activityMode === "schedule" || this.activityMode === "both") && (!this.getDynamicActivitySchedules || !this.getDynamicActivitySchedules.length || (this.getDynamicActivitySchedules && this.getDynamicActivitySchedules.length && this.getDynamicActivitySchedules.length < DynamicSchedulingConstants.DYNAMIC_SCHEDULES_LIMIT));
    },
    ...mapGetters(["getDynamicActivitySchedules", "getDynamicSchedulingServiceData"])
  },
  watch: {
    taskDetails: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          if (this.dynamicSchedulingService) {
            this.getDynamicActivitySchedules.taskDetails = this.dynamicSchedulingService.taskDetails = newVal;
          }
        }
      }
    },
    schedulerDetails: {
      deep: true,
      immediate: true,
      handler() {
        this.populateDynamicSchedulesInVuex();
      }
    },
    studyData: {
      deep: true,
      immediate: true,
      handler: function(newInfo) {
        if (newInfo) {
          this.dynamicSchedulingService = new DynamicSchedulingService();
          this.dynamicSchedulingService.studyDetails = newInfo;
          this.setDynamicSchedulingServiceData(this.dynamicSchedulingService);
          this.getDynamicActivitySchedules.taskDetails = this.dynamicSchedulingService.taskDetails = cloneDeep(this.taskDetails);
          this.getTriggerDetails();
        }
      }
    },
    triggersRelatedDetails: {
      deep: true,
      immediate: true,
      handler: function(newData) {
        if (newData && this.dynamicSchedulingService) {
          this.dynamicSchedulingService.registrationConfigDetails = newData.registrationConfigWrapper && newData.registrationConfigWrapper.participantRegistrationConfigDetails;
        }
      }
    }
  },
  data() {
    return {
      surveyDetails: null,
      triggersRelatedDetails: null
    };
  },
  mounted() {},
  methods: {
    ...mapActions(["setDynamicActivitySchedules", "setConstantDynamicActivitySchedules", "setDynamicActivityScheduleForEditing", "setDynamicSchedulingServiceData"]),
    openDynamicSchedulerModalAdd() {
      this.$refs.DynamicActivitySchedulingModal.openModal();
      const addData = {
        addOrEditMode: "add",
        index: null,
        data: null
      };
      this.setDynamicActivityScheduleForEditing(addData);
    },
    openDynamicSchedulerModalEdit() {
      this.$refs.DynamicActivitySchedulingModal.openModal();
    },
    populateDynamicSchedulesInVuex() {
      if (this.schedulerDetails && this.schedulerDetails.dynamicScheduling && this.schedulerDetails.dynamicScheduling.length) {
        const dynamicSchedules = cloneDeep(this.schedulerDetails.dynamicScheduling);

        const mileList = [];
        for (let d = 0; d < dynamicSchedules.length; d++) {
          // BACKWARD-COMPATIBILITY : To make multi-row actions: Add an Activity / Remove an Activity, club in 1 row together
          const actionsList = [];
          let addAnActivityAction = null;

          let removeAnActivityAction = null;
          dynamicSchedules[d].actions.forEach(action => {
            if (action.type == DynamicSchedulingConstants.ACTION_NAME.ADD_AN_ACTIVITY) {
              if (!addAnActivityAction) {
                const task = _.cloneDeep(action);
                actionsList.push(task);
                addAnActivityAction = task;
                addAnActivityAction.tasks = [];
              }
              addAnActivityAction.tasks.push(...action.tasks);
            } else if (action.type == DynamicSchedulingConstants.ACTION_NAME.REMOVE_AN_ACTIVITY) {
              if (!removeAnActivityAction) {
                const task = _.cloneDeep(action);
                actionsList.push(task);
                removeAnActivityAction = task;
                removeAnActivityAction.tasks = [];
              }
              removeAnActivityAction.tasks.push(...action.tasks);
            } else {
              actionsList.push(action);
            }
          });
          dynamicSchedules[d].actions = actionsList;

          const sch = dynamicSchedules[d].scheduling[0];
          if (sch && sch.type === "milestone") {
            sch["completionWindow"] = sch.completionDuration;
            for (const i in sch.milestonesList) {
              const mile = sch.milestonesList[i];
              for (const j in sch.milestones) {
                if (mile.milestoneDay === sch.milestones[j]) {
                  mileList.push(mile);
                  break;
                }
              }
            }
            sch.milestonesList = mileList;
            // To maintain Backward compatibility for dynamic schedules saved with common completion window.
            sch["completionWindows"] = sch["completionWindows"] ? sch["completionWindows"] : this.assignCompletionWindowToEverySelectedMilestones(sch["completionWindow"], sch.milestones);
          } else if (sch && sch.type === "custom") {
            sch["completionWindow"] = sch.completionDuration;
          }
        }
        this.setDynamicActivitySchedules(dynamicSchedules);
        this.setConstantDynamicActivitySchedules(cloneDeep(dynamicSchedules));
      } else {
        this.setDynamicActivitySchedules([]);
      }
    },
    assignCompletionWindowToEverySelectedMilestones(completionWindow, selectedMiles) {
      const completioWindows = {};
      selectedMiles.forEach(mile => {
        completioWindows[mile] = completionWindow;
      });
      return completioWindows;
    },
    getTriggerDetails() {
      const _this = this;
      this.$api.getTriggerDetails(this.$route.params.studyId).then(data => {
        const triggersRelatedDetails = data.body;
        if (triggersRelatedDetails.registrationConfigWrapper && triggersRelatedDetails.registrationConfigWrapper.participantRegistrationConfigDetails && triggersRelatedDetails.registrationConfigWrapper.participantRegistrationConfigDetails.length) {
          let registrationDetails = triggersRelatedDetails.registrationConfigWrapper.participantRegistrationConfigDetails;
          registrationDetails = registrationDetails.map(x => {
            if (x.key == "gender") {
              x.lookupExpectedValue = x.lookupExpectedValue.map(({ identifier, values }) => ({
                identifier,
                values: values.includes("Other") ? "Other" : values
              }));
            }
            return x;
          });
          triggersRelatedDetails.registrationConfigWrapper.participantRegistrationConfigDetails = registrationDetails;
        }
        this.getDynamicActivitySchedules.registrationConfigDetails = _this.triggersRelatedDetails = triggersRelatedDetails;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.bt-1 {
  border-top: 1px solid #d3dfe4;
}
.divider-line {
  height: 1px;
  width: 100%;
  border-bottom: 1px solid #d3dfe4;
}
.dynamic-activity-scheduler-btn {
  border-radius: 4px;
  border: solid 1px #4c8ce4;
  background: #fff;
  font-family: "RobotoRegular";
  font-size: 15px;
  color: #4c8ce4;
  padding: 7px 12px 8px 39px;
  position: relative;

  &:hover {
    cursor: pointer;
    color: #649be8;
    border: solid 1px #649be8;
    box-shadow: 0 1px 0px 0 rgba(230, 230, 230, 2%), 0 1px 9px 0 rgba(230, 230, 230, 19%);
  }
  &:active {
    cursor: pointer;
    color: #4c8ce4;
    border: solid 1px #4c8ce4;
    box-shadow: none;
  }
  & .das-icon {
    background: url(/static/img/dynamic-only-blue-icon.svg) no-repeat;
    width: 28px;
    height: 23px;
    float: left;
    position: absolute;
    left: 9px;
    top: 9px;
  }
}
</style>
